// TODO: pasar followCompany al componente ArticleFollowCompany
// @flow
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Flex } from '@finect/tabular-core/Flex';
import { Icon } from '@finect/tabular-components/Icon';
import { ProductItem } from '@finect/tabular-components/ProductItem';
import { HTML } from '@finect/tabular-components/HTML';
import { getWidgetComponent, Podcast, normalizeVideo } from '@finect/tabular-components/Articles';
import { EmbeddedVideo } from '@finect/tabular-components/Videos';
import { ArticleContentSubtitles } from '@finect/tabular-components/ArticleContentSubtitles';
import {
  ArticleContentBody,
  Follow,
  FollowCompany,
  AuthorFollow,
  FollowAction,
  RelatedProductItem,
  RelatedProductsContent
  // HTML
} from '../../../../components';
import { replacePtoH4, buildHTML } from './utils';
import { BodyInner, VideoBlock } from './partials';

type Props = {
  article: Object,
  html: string,
  settingTagContent?: Object,
  settingPillAdvisersLeads?: Object,
  onProfileFollow: Function,
  profileSubscriptions: Array<string>
};

export class ArticleBody extends React.Component<Props> {
  handleWindowResize: () => void = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    typeof window !== 'undefined' && window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    typeof window !== 'undefined' && window.removeEventListener('resize', this.handleWindowResize);
  }

  render() {
    const { article, html: htmlProp, settingTagContent = {}, settingPillAdvisersLeads = {} } = this.props;
    const { author, subtitles } = article;
    const isCompany = article.author.subtype === 'company';

    const subtitlesHTML = subtitles
      .map(subtitle => (typeof subtitle === 'object' ? replacePtoH4(subtitle.text) : replacePtoH4(subtitle)))
      .join('\n');

    let html = buildHTML(htmlProp, settingTagContent || null, article.widgets);

    // add advisers pill on replaceText or at the end of the article
    const containsPillReplaceText = html.includes(settingPillAdvisersLeads.replaceText);
    const constainsPillHardcoded = html.includes('advisers-cta');

    if (article.includePillAdvisersLeads && settingPillAdvisersLeads?.value === 1 && !constainsPillHardcoded) {
      const advisersPill = `${
        settingPillAdvisersLeads.text ? `<p>${settingPillAdvisersLeads.text}</p>` : ''
      }<div class="advisers-cta"></div>`;

      if (containsPillReplaceText) html = html.replace(settingPillAdvisersLeads.replaceText, advisersPill);
      else html += advisersPill;
    } else if (containsPillReplaceText) {
      html = html.replace(settingPillAdvisersLeads.replaceText, '');
    }

    return (
      <BodyInner>
        {subtitles.length ? (
          <HTML getWidgetComponent={getWidgetComponent} html={subtitlesHTML} wrapper={ArticleContentSubtitles} />
        ) : null}

        {['video'].includes(article.type) ? (
          <VideoBlock>
            <EmbeddedVideo video={normalizeVideo(article.url)} />
          </VideoBlock>
        ) : null}

        {['podcast'].includes(article.type) ? (
          <VideoBlock>
            <Podcast url={article.url} />
          </VideoBlock>
        ) : null}

        <HTML getWidgetComponent={getWidgetComponent} html={html} wrapper={ArticleContentBody} />

        {article.relatedProducts?.length > 0 ? (
          <RelatedProductsContent>
            {article.relatedProducts
              .filter(item => item.entity.name)
              .map(item => (
                <RelatedProductItem key={item.entity.id}>
                  <ProductItem subtype={item.subtype} entity={item.entity} withLink />
                </RelatedProductItem>
              ))}
          </RelatedProductsContent>
        ) : null}

        {isCompany ? (
          <FollowCompany>
            <AuthorFollow lined following={this.props.profileSubscriptions.includes(author.id)}>
              <Flex align="center">
                <AppLink href={`/grupos/${author.alias}`}>
                  <Icon
                    size={3}
                    alt={article.author.displayName}
                    image={`/image/${article.author.icon}`}
                    margin="0 18px 0 0"
                    type="company"
                  />
                </AppLink>

                <div>
                  <h3>
                    {this.props.profileSubscriptions.includes(author.id)
                      ? 'Gracias por seguir a '
                      : 'No te pierdas nada de '}
                    {article.author.displayName}
                  </h3>
                  <span>
                    {this.props.profileSubscriptions.includes(author.id)
                      ? `Estás suscrito a todas las publicaciones de ${article.author.displayName}`
                      : 'Síguenos y recibe nuestras próximas publicaciones en tu email.'}
                  </span>
                </div>
              </Flex>
              <FollowAction>
                <Follow
                  follow={this.props.onProfileFollow}
                  following={this.props.profileSubscriptions.includes(author.id)}
                  followers={article.author.stats.subscribers}
                  primary
                />
              </FollowAction>
            </AuthorFollow>
          </FollowCompany>
        ) : null}
      </BodyInner>
    );
  }
}
